import React, { useEffect, useState } from "react";
import { database } from "../../../services/firebase";
import { ref, get } from "firebase/database";

const Geography = () => {
  const [questions, setQuestions] = useState([]);
  const [openIndex, setOpenIndex] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchQuestions = async () => {
      try {
        const dbRef = ref(database, "prlimsgs1geography");
        const snapshot = await get(dbRef);

        console.log("SNAPSHOT EXISTS:", snapshot.exists());
        console.log("SNAPSHOT VALUE:", snapshot.val());

        if (snapshot.exists()) {
          const data = snapshot.val();

          const formattedData = Array.isArray(data)
            ? data
            : Object.values(data);

          setQuestions(formattedData);
        } else {
          console.log("❌ No data found at this path");
          setQuestions([]);
        }
      } catch (error) {
        console.error("🔥 Firebase Fetch Error:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchQuestions();
  }, []);

  const toggleAnswer = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div
      className="container-fluid py-5"
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #020617, #0f172a, #111827)",
        color: "#fff"
      }}
    >
      <div className="container">

        {/* HEADER */}
        <div className="text-center mb-5">
          <div
            style={{
              display: "inline-block",
              padding: "10px 22px",
              borderRadius: "50px",
              background: "rgba(255,255,255,0.08)",
              border: "1px solid rgba(255,255,255,0.12)",
              backdropFilter: "blur(10px)",
              boxShadow: "0 8px 30px rgba(0,0,0,0.25)"
            }}
          >
            <span
              style={{
                fontWeight: "700",
                fontSize: "14px",
                letterSpacing: "1px",
                color: "#38bdf8"
              }}
            >
              UPSC PREMIUM ACCESS
            </span>
          </div>

          <h1
            className="fw-bold mt-4"
            style={{
              fontSize: "2.4rem",
              background: "linear-gradient(90deg, #ffffff, #cbd5e1, #38bdf8)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent"
            }}
          >
            📘 Geography
          </h1>

          <p
            className="mt-3"
            style={{
              color: "#cbd5e1",
              fontSize: "1.05rem",
              maxWidth: "750px",
              margin: "0 auto",
              lineHeight: "1.8"
            }}
          >
            Premium-level question bank with detailed answers and concept-based explanations
            designed for deep UPSC Prelims mastery.
          </p>
        </div>

        {/* LOADING */}
        {loading ? (
          <div className="text-center mt-5">
            <div
              className="spinner-border"
              role="status"
              style={{ width: "3rem", height: "3rem", color: "#38bdf8" }}
            ></div>
            <p className="mt-4 fw-semibold fs-5" style={{ color: "#e2e8f0" }}>
              Loading premium questions...
            </p>
          </div>
        ) : questions.length === 0 ? (
          <div className="text-center mt-5">
            <div
              style={{
                maxWidth: "700px",
                margin: "0 auto",
                background: "rgba(255,255,255,0.06)",
                border: "1px solid rgba(255,255,255,0.08)",
                borderRadius: "24px",
                padding: "40px 30px",
                backdropFilter: "blur(16px)",
                boxShadow: "0 20px 60px rgba(0,0,0,0.35)"
              }}
            >
              <h3 className="fw-bold mb-3">⚠️ No questions found in database</h3>
              <p style={{ color: "#cbd5e1", marginBottom: 0 }}>
                Please check your Firebase path:
                <br />
                <strong style={{ color: "#38bdf8" }}>
                  prlimsgs1indianpolityandgover
                </strong>
              </p>
            </div>
          </div>
        ) : (
          <div className="d-flex flex-column gap-4">

            {questions.map((item, index) => (
              <div
                key={index}
                style={{
                  position: "relative",
                  borderRadius: "28px",
                  padding: "2px",
                  background:
                    "linear-gradient(135deg, rgba(56,189,248,0.45), rgba(168,85,247,0.35), rgba(34,197,94,0.35))",
                  boxShadow:
                    "0 25px 80px rgba(0,0,0,0.35), 0 10px 30px rgba(56,189,248,0.08)"
                }}
              >
                <div
                  style={{
                    borderRadius: "26px",
                    background:
                      "linear-gradient(145deg, rgba(15,23,42,0.95), rgba(17,24,39,0.92))",
                    backdropFilter: "blur(16px)",
                    padding: "30px",
                    border: "1px solid rgba(255,255,255,0.06)"
                  }}
                >
                  {/* TOP BAR */}
                  <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3">
                    <div
                      style={{
                        background: "rgba(56,189,248,0.12)",
                        border: "1px solid rgba(56,189,248,0.25)",
                        color: "#38bdf8",
                        padding: "8px 18px",
                        borderRadius: "999px",
                        fontWeight: "700",
                        fontSize: "14px",
                        boxShadow: "inset 0 0 20px rgba(56,189,248,0.08)"
                      }}
                    >
                      Question {index + 1}
                    </div>

                    <div className="d-flex flex-wrap gap-2">
                      <span
                        style={{
                          background: "rgba(168,85,247,0.15)",
                          color: "#e9d5ff",
                          padding: "8px 16px",
                          borderRadius: "999px",
                          fontSize: "13px",
                          fontWeight: "600",
                          border: "1px solid rgba(168,85,247,0.2)"
                        }}
                      >
                        {item.category || "UPSC"}
                      </span>

                      <span
                        style={{
                          background: "rgba(34,197,94,0.12)",
                          color: "#bbf7d0",
                          padding: "8px 16px",
                          borderRadius: "999px",
                          fontSize: "13px",
                          fontWeight: "600",
                          border: "1px solid rgba(34,197,94,0.2)"
                        }}
                      >
                        {item.subcategory || "Prelims"}
                      </span>
                    </div>
                  </div>

                  {/* QUESTION */}
                  <div className="mb-4">
                    <h3
                      style={{
                        fontSize: "1.4rem",
                        lineHeight: "1.8",
                        fontWeight: "800",
                        color: "#f8fafc",
                        marginBottom: "0"
                      }}
                    >
                      {item.question}
                    </h3>
                  </div>

                  {/* ACTION BUTTON */}
                  <div className="mb-3">
                    <button
                      className="btn"
                      onClick={() => toggleAnswer(index)}
                      style={{
                        borderRadius: "16px",
                        padding: "14px 26px",
                        fontWeight: "700",
                        fontSize: "15px",
                        color: "#fff",
                        border: "none",
                        background:
                          openIndex === index
                            ? "linear-gradient(135deg, #ef4444, #dc2626)"
                            : "linear-gradient(135deg, #22c55e, #16a34a)",
                        boxShadow:
                          openIndex === index
                            ? "0 10px 25px rgba(239,68,68,0.35)"
                            : "0 10px 25px rgba(34,197,94,0.35)",
                        transition: "all 0.3s ease"
                      }}
                    >
                      {openIndex === index ? "Hide Answer" : "View Answer"}
                    </button>
                  </div>

                  {/* ANSWER SECTION */}
                  {openIndex === index && (
                    <div
                      style={{
                        marginTop: "24px",
                        borderRadius: "22px",
                        padding: "28px",
                        background:
                          "linear-gradient(145deg, rgba(255,255,255,0.05), rgba(255,255,255,0.03))",
                        border: "1px solid rgba(255,255,255,0.08)",
                        boxShadow: "inset 0 0 30px rgba(255,255,255,0.02)"
                      }}
                    >
                      <div className="mb-4">
                        <h5
                          style={{
                            color: "#22c55e",
                            fontWeight: "800",
                            marginBottom: "12px"
                          }}
                        >
                          ✅ Correct Answer
                        </h5>

                        <div
                          style={{
                            fontSize: "1.15rem",
                            fontWeight: "700",
                            color: "#f8fafc",
                            background: "rgba(34,197,94,0.08)",
                            padding: "16px 18px",
                            borderRadius: "16px",
                            border: "1px solid rgba(34,197,94,0.15)"
                          }}
                        >
                          {item.answer}
                        </div>
                      </div>

                      <div>
                        <h5
                          style={{
                            color: "#38bdf8",
                            fontWeight: "800",
                            marginBottom: "12px"
                          }}
                        >
                          📖 Explanation
                        </h5>

                        <div
                          style={{
                            color: "#cbd5e1",
                            fontSize: "1rem",
                            lineHeight: "1.9",
                            background: "rgba(56,189,248,0.06)",
                            padding: "18px",
                            borderRadius: "16px",
                            border: "1px solid rgba(56,189,248,0.12)"
                          }}
                        >
                          {item.explanation}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ))}

          </div>
        )}
      </div>
    </div>
  );
};

export default Geography;